import { useContext } from 'react'
import PinContext, { IPinContext } from 'services/Pin/context'

export const usePinContext = (): IPinContext => useContext(PinContext)

export default usePinContext
